var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-views-menu"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "max-width": "360",
      "min-width": "300"
    },
    on: {
      "input": _vm.onMenuInput
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref2) {
              var tooltipOn = _ref2.on,
                tooltipAttrs = _ref2.attrs;
              return [_c('button', _vm._g(_vm._b({
                staticClass: "table-toolbar__action",
                "class": {
                  'table-toolbar__action--active': _vm.menuOpen
                },
                attrs: {
                  "type": "button",
                  "aria-label": _vm.$translate('savedViews')
                }
              }, 'button', Object.assign({}, attrs, tooltipAttrs), false), Object.assign({}, on, tooltipOn)), [_c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-bookmark-outline")]), _vm.hasActiveView || _vm.activeViewId ? _c('span', {
                staticClass: "table-toolbar__badge-dot",
                attrs: {
                  "aria-hidden": "true"
                }
              }) : _vm._e()], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v(_vm._s(_vm.$translate("savedViews")))])])];
      }
    }]),
    model: {
      value: _vm.menuOpen,
      callback: function callback($$v) {
        _vm.menuOpen = $$v;
      },
      expression: "menuOpen"
    }
  }, [_c('v-card', {
    staticClass: "table-views-menu__panel"
  }, [_c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": ""
    }
  }, [_vm.loading ? _c('v-list-item', {
    attrs: {
      "disabled": ""
    }
  }, [_c('v-list-item-title', {
    staticClass: "text-caption grey--text"
  }, [_vm._v(" " + _vm._s(_vm.$translate("loading")) + " ")])], 1) : !_vm.views.length ? _c('v-list-item', {
    attrs: {
      "disabled": ""
    }
  }, [_c('v-list-item-title', {
    staticClass: "text-caption grey--text"
  }, [_vm._v(" " + _vm._s(_vm.$translate("noViews")) + " ")])], 1) : _vm._e(), _vm._l(_vm.views, function (view, index) {
    return _c('v-list-item', {
      key: view.id,
      "class": {
        'table-views-menu__item--active': _vm.activeViewId === view.id
      },
      on: {
        "click": function click($event) {
          return _vm.applyView(view);
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.viewLabel(view, index)) + " ")])], 1), _c('v-list-item-action', {
      staticClass: "flex-row ma-0"
    }, [_vm.activeViewId === view.id ? _c('v-btn', {
      attrs: {
        "icon": "",
        "x-small": "",
        "aria-label": _vm.$translate('saveFilters'),
        "loading": _vm.savingFilters,
        "disabled": _vm.savingFilters || !_vm.canSave
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.saveActiveViewFilters(view);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "x-small": ""
      }
    }, [_vm._v("mdi-content-save-outline")])], 1) : _vm._e(), _c('v-btn', {
      attrs: {
        "icon": "",
        "x-small": "",
        "aria-label": _vm.$translate('renameView')
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.openRenameDialog(view);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "x-small": ""
      }
    }, [_vm._v("mdi-pencil")])], 1), _c('v-btn', {
      attrs: {
        "icon": "",
        "x-small": "",
        "aria-label": _vm.$translate('delete')
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.confirmDelete(view);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "x-small": ""
      }
    }, [_vm._v("mdi-delete-outline")])], 1)], 1)], 1);
  })], 2), _c('v-divider'), _c('div', {
    staticClass: "pa-2"
  }, [_c('button', {
    staticClass: "table-views-menu__add",
    attrs: {
      "type": "button",
      "disabled": !_vm.canSave
    },
    on: {
      "click": _vm.openCreateDialog
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$translate("createView")) + " ")], 1)])], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": "420",
      "persistent": ""
    },
    model: {
      value: _vm.createDialog,
      callback: function callback($$v) {
        _vm.createDialog = $$v;
      },
      expression: "createDialog"
    }
  }, [_c('v-card', {
    staticClass: "table-views-save-dialog"
  }, [_c('v-card-title', {
    staticClass: "table-views-save-dialog__title"
  }, [_c('div', {
    staticClass: "table-views-save-dialog__title-icon"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": "22"
    }
  }, [_vm._v("mdi-bookmark-plus-outline")])], 1), _c('div', [_c('div', {
    staticClass: "table-views-save-dialog__heading"
  }, [_vm._v(" " + _vm._s(_vm.$translate("createDialogTitle")) + " ")]), _c('div', {
    staticClass: "table-views-save-dialog__subtitle"
  }, [_vm._v(" " + _vm._s(_vm.$translate("createDialogSubtitle")) + " ")])])]), _c('v-card-text', {
    staticClass: "table-views-save-dialog__body"
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$translate('viewNameLabel'),
      "error-messages": _vm.createNameErrors,
      "outlined": "",
      "dense": "",
      "autofocus": "",
      "counter": "128",
      "maxlength": "128",
      "hide-details": "auto"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.confirmCreate.apply(null, arguments);
      }
    },
    model: {
      value: _vm.createName,
      callback: function callback($$v) {
        _vm.createName = $$v;
      },
      expression: "createName"
    }
  })], 1), _c('v-card-actions', {
    staticClass: "table-views-save-dialog__actions"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "px-3",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeCreateDialog
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("cancel")) + " ")]), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "color": "primary",
      "depressed": "",
      "loading": _vm.saving,
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.confirmCreate
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("create")) + " ")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": "420",
      "persistent": ""
    },
    model: {
      value: _vm.renameDialog,
      callback: function callback($$v) {
        _vm.renameDialog = $$v;
      },
      expression: "renameDialog"
    }
  }, [_c('v-card', {
    staticClass: "table-views-save-dialog"
  }, [_c('v-card-title', {
    staticClass: "table-views-save-dialog__title"
  }, [_c('div', {
    staticClass: "table-views-save-dialog__title-icon"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": "22"
    }
  }, [_vm._v("mdi-pencil-outline")])], 1), _c('div', [_c('div', {
    staticClass: "table-views-save-dialog__heading"
  }, [_vm._v(" " + _vm._s(_vm.$translate("renameDialogTitle")) + " ")]), _c('div', {
    staticClass: "table-views-save-dialog__subtitle"
  }, [_vm._v(" " + _vm._s(_vm.$translate("renameDialogSubtitle")) + " ")])])]), _c('v-card-text', {
    staticClass: "table-views-save-dialog__body"
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$translate('viewNameLabel'),
      "error-messages": _vm.renameNameErrors,
      "outlined": "",
      "dense": "",
      "autofocus": "",
      "counter": "128",
      "maxlength": "128",
      "hide-details": "auto"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.confirmRename.apply(null, arguments);
      }
    },
    model: {
      value: _vm.renameName,
      callback: function callback($$v) {
        _vm.renameName = $$v;
      },
      expression: "renameName"
    }
  })], 1), _c('v-card-actions', {
    staticClass: "table-views-save-dialog__actions"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "px-3",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeRenameDialog
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("cancel")) + " ")]), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "color": "primary",
      "depressed": "",
      "loading": _vm.renaming,
      "disabled": _vm.renaming
    },
    on: {
      "click": _vm.confirmRename
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("rename")) + " ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }